// Phone number utilities
export const normalizePhoneNumber = (phone: string): string => {
  // Remove all non-digit characters
  return phone.replace(/\D/g, '');
};

export const isValidIranPhoneNumber = (phone: string): boolean => {
  const normalized = normalizePhoneNumber(phone);
  return normalized.length === 11 && normalized.startsWith('09');
};

export const getPhoneValidationMessage = (phone: string): string | null => {
  const normalized = normalizePhoneNumber(phone);
  if (!normalized) {
    return 'شماره موبایل را وارد کنید';
  }
  if (!normalized.startsWith('09')) {
    return 'شماره موبایل باید با 09 شروع شود';
  }
  if (normalized.length !== 11) {
    return 'شماره موبایل باید ۱۱ رقم باشد';
  }
  return null;
};

export const formatPhoneNumber = (phone: string): string => {
  const normalized = normalizePhoneNumber(phone);
  // Add formatting if needed (e.g., +98 for Iran)
  if (normalized.startsWith('09')) {
    return normalized;
  }
  if (normalized.startsWith('9')) {
    return '0' + normalized;
  }
  return normalized;
};
